// src/services/infoCentre/formateurService.js
import api from '../api';

const BASE = 'formateurs/';

// ── GET /api/formateurs/           → formateurs actifs
// ── GET /api/formateurs/?archive=1 → formateurs archivés
export const getFormateurs = async (archive = false) => {
  const response = await api.get(BASE, { params: archive ? { archive: 1 } : {} });
  return response.data;
};

// ── POST /api/formateurs/
export const createFormateur = async (formData) => {
  const response = await api.post(BASE, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

// ── PUT /api/formateurs/:id/
export const updateFormateur = async (id, formData) => {
  const response = await api.put(`${BASE}${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

// ── DELETE /api/formateurs/:id/
export const deleteFormateur = async (id) => {
  const response = await api.delete(`${BASE}${id}/`);
  return response.data;
};

// ── GET /api/formateurs/:id/
export const getFormateurById = async (id) => {
  const response = await api.get(`${BASE}${id}/`);
  return response.data;
};

// ── POST /api/formateurs/archiver/
export const archiverFormateurs = async (ids) => {
  const response = await api.post(`${BASE}archiver/`, { ids });
  return response.data;
};

// ── POST /api/formateurs/desarchiver/
export const desarchiverFormateurs = async (ids) => {
  const response = await api.post(`${BASE}desarchiver/`, { ids });
  return response.data;
};